import {
  BarChartOutlined,
  FunnelPlotOutlined,
  LineChartOutlined,
  PieChartOutlined
} from '@ant-design/icons'
import {
  ChartTypeEnum,
  ReportReturnReadable,
  reportsListOptions
} from '@crm/api'
import { useAppNavigate } from '@crm/hooks/useAppNavigate'
import { paths } from '@crm/routes'
import { useLocales } from '@shared/locales'
import { useQuery } from '@tanstack/react-query'
import { Flex, Select, Typography } from 'antd'
import { useMemo } from 'react'
import { useParams } from 'react-router-dom'

const { Text } = Typography

const genericIcons: Record<ChartTypeEnum, React.ReactNode> = {
  funnel: <FunnelPlotOutlined />,
  pie: <PieChartOutlined />,
  line: <LineChartOutlined />,
  bar: <BarChartOutlined />
}

export const ReportSelect = () => {
  const { id: reportId } = useParams()
  const navigate = useAppNavigate()
  const { t } = useLocales()

  const { data: reports, isLoading } = useQuery(reportsListOptions())

  const reportsOptions = useMemo(
    () =>
      reports?.map(({ id, name, chart_type }: ReportReturnReadable) => ({
        value: id,
        label: (
          <Flex gap={4}>
            {genericIcons[chart_type as ChartTypeEnum]}

            <Text ellipsis={{ tooltip: { title: name } }}>{name}</Text>
          </Flex>
        )
      })) ?? [],
    [reports]
  )

  return (
    <Select
      value={reportId ? parseInt(reportId) : undefined}
      placeholder={t('reports.generic')}
      className="select-min-width"
      loading={isLoading}
      allowClear
      options={reportsOptions}
      onChange={(id) => {
        navigate(
          id ? paths.reports.generic(id.toString()) : paths.reports.dashboard
        )
      }}
    />
  )
}
